import React from "react";
import { FaUser, FaCalendarAlt, FaChurch, FaBook } from "react-icons/fa";
import dayjs from "dayjs";

const ConfirmationView = ({ currentRecord }) => {
  return (
    <div className="overflow-hidden bg-white rounded-lg shadow-lg">
      <div className="p-4 text-white bg-blue-600">
        <h2 className="text-2xl font-semibold">Confirmation Details</h2>
      </div>
      <InfoTable jsonData={currentRecord} />
    </div>
  );
};

export default ConfirmationView;

const InfoTable = ({ jsonData }) => {
  const keysToShow = Object.keys(jsonData).filter(
    (key) =>
      ![
        "__v",
        "id",
        "createdAt",
        "church_id",
        "createdBy",
        "updatedAt",
        "_id",
      ].includes(key)
  );

  const formatDate = (dateString) => {
    return dayjs(dateString).utc().format("MM/DD/YYYY");
  };

  const getIcon = (key) => {
    if (key.includes("name")) return <FaUser className="text-blue-500" />;
    if (key.includes("date"))
      return <FaCalendarAlt className="text-green-500" />;
    if (key.includes("church")) return <FaChurch className="text-purple-500" />;
    return <FaBook className="text-yellow-500" />;
  };

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {keysToShow.map((key) => {
          const isDateField =
            key.includes("date_of_birth") ||
            key === "confirmation_date" ||
            key === "date_of_baptism";
          const value = jsonData[key];
          const displayValue =
            isDateField && typeof value === "string"
              ? formatDate(value)
              : typeof value === "object" && value !== null
              ? value.label
              : value;

          return (
            <div key={key} className="p-4 bg-gray-50 rounded-lg shadow">
              <div className="flex items-center mb-2">
                {getIcon(key)}
                <span className="ml-2 text-sm font-medium text-gray-500">
                  {key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                </span>
              </div>
              <p className="text-lg font-semibold text-gray-800">
                {displayValue}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
